import * as React from 'react';
import { useState } from 'react';

import { Button } from '@components/common';
import { isRuleEmpty } from '@components/GQSurveyBuilder/components/RuleBuilder/useQuestionRules';
import type { Rule } from '@components/GQSurveyBuilder/components/utils';

import { DeleteRuleModal } from './components';

interface SlideoutFooterProps {
  isLoading: boolean;
  groupedRules: Rule[];
  onSave: () => void;
  onCancel: () => void;
  onRemoveAll: () => void;
  showRemoveAll?: boolean;
}

export const QuestionConfigSlideoutFooter: React.FC<SlideoutFooterProps> = ({
  isLoading,
  groupedRules,
  onSave,
  onCancel,
  onRemoveAll
}) => {
  const [showRemoveAllModal, setShowRemoveAllModal] = useState(false);

  const handleRemoveAll = () => {
    onRemoveAll();
    setShowRemoveAllModal(false);
  };

  const hasRealRules = groupedRules.some((rule) => !isRuleEmpty(rule));

  return (
    <>
      <div className='space-x-2'>
        <Button loading={isLoading} disabled={isLoading} onClick={onSave} primary>
          Save
        </Button>
        <Button disabled={isLoading} onClick={onCancel}>
          Cancel
        </Button>
        <Button disabled={isLoading || !hasRealRules} onClick={() => setShowRemoveAllModal(true)}>
          Remove all logic
        </Button>
      </div>

      {showRemoveAllModal && (
        <DeleteRuleModal context='all' onClose={() => setShowRemoveAllModal(false)} onConfirm={handleRemoveAll} />
      )}
    </>
  );
};
